import { useMe } from './useMe.js';

/**
 * Convenience hook — exposes the active scope of the session.
 * Pages that aggregate (cash-flow, stats, à payer) branch on `isGroup`.
 * Pages that require a single entity render `<RequiresSingleEntity>` instead.
 */
export function useEntityScope() {
  const { data: me, isLoading, error } = useMe();
  const memberships = me?.memberships ?? [];
  const isGroup = me?.scope === 'group';
  const activeMembership = memberships.find((m) => m.entity_id === me?.active_entity_id) ?? null;

  return {
    isLoading,
    error,
    isGroup,
    memberships,
    activeMembership,
    activeEntityId: me?.active_entity_id ?? null,
    activeEntityName: isGroup ? 'Vue groupe' : (activeMembership?.name ?? null),
  };
}
